import { Flex } from '@/ui';
import { Text } from '@/ui/typography';
import { STATUS_COLOR, STATUS_DISPLAY, STATUS_VERIFICATION_DISPLAY } from '@/utils/static/kyc';
import { STATUS_ICON } from '../constants';
import { getFontSize, getFlexGap, isSmallScreen } from '../utils';
import { useTranslation } from 'react-i18next';

export const StatusColumn = ({ status, name, windowWidth }) => {
  const { t } = useTranslation();
  const smallScreen = isSmallScreen(windowWidth);
  const fontSize = getFontSize(windowWidth);
  const gap = getFlexGap(windowWidth);

  const statusText =
    name === 'Identification'
      ? `${t(STATUS_VERIFICATION_DISPLAY[status])}`.toLowerCase()
      : `${t(STATUS_DISPLAY[status])}`.toLowerCase();

  return (
    <Flex
      vertical={smallScreen}
      align={smallScreen ? 'flex-start' : 'center'}
      gap={gap}
    >
      {STATUS_ICON[status]}
      <Text
        $fontWeight={600}
        $fontSize={fontSize}
        $color={STATUS_COLOR[status]}
      >
        {statusText}
      </Text>
    </Flex>
  );
};

